export const de = {
    editorSessionExpired: 'Die Editorsitzung ist abgelaufen',
    editorDelete: 'Löschen',
    editorEdit: 'Bearbeiten',
    editorCancel: 'Stornieren',
    editorSubmit: 'Einreichen',
    editorTemplatesTitle: 'Vorlagen',
    editorTemplatesCreate: 'Neue Vorlage erstellen',
    editorTemplatesSetNewName: 'Neuer Name für Format',
    editorTemplatesCreateNew: 'Erstellen Sie eine neue Formatvorlage',
    editorTemplatesName: 'Formatname',
    editorTemplatesWidth: 'Formatbreite [mm]',
    editorTemplatesHeight: 'Formathöhe [mm]',
    editorTemplatesBleed: 'Formatieren Sie Beschnitt [mm]',
    editorTemplatesEditName: 'Bearbeiten Sie den Namen {formatName}',
    editorTemplateWarning: 'Dieses Format enthält Projekte. Das Löschen eines Formats bedeutet das Löschen von Projekten. Wollen Sie fortfahren?',
    editorTemplateRemove: 'Ja, Format und seine Projekte löschen',
    editorProjectsTitle: 'Vorlagen> Projekte',
    editorProjectsCreateNew: 'Neues Projekt erstellen',
    editorProjectsName: 'Projektname',
    editorProjectsDescription: 'Projektbeschreibung',
    editorProjectsWarning: 'Dieses Projekt enthält Elemente. Ein Projekt löschen bedeutet, Elemente zu löschen. Wollen Sie fortfahren?',
    editorProjectsRemove: 'Ja, löschen Sie das Projekt und seine Elemente',
    editorProjectEdit: 'Projekt bearbeiten',
    editorPlaceholdersTitle: 'Platzhalter',
    editorPlaceholdersName: 'Name',
    editorPlaceholdersSystemName: 'Systemname',
    editorPlaceholdersAddNew: 'Neue hinzufügen',
    editorPlaceholdersCreateNew: 'Erstelle neu',
    editorPlaceholdersUpdate: 'Platzhalter aktualisieren',
    editorPlaceholdersRemove: 'Entfernen',
    editorTabItemProjects: 'Projekte',
    editorTabItemUploads: 'Uploads',
    editorTabItemFrames: 'Rahmen',
    editorTabItemText: 'Text hinzufügen',
    editorTabItemShapes: 'Shapes',
    editorTabItemForms: 'Forms',
    editorTabFontTitle: 'Wählen Sie eine Schriftart',
    editorTabTextNewItemContent: 'Doppelklick zum bearbeiten. Klicken und ziehen Sie, um sich zu bewegen.',
    editorTabShapesTitle: 'Grundformen',
    editorTabQrTitle: 'QR-Code',
    editorTabQrNewItemContent: 'Qr-Code-Text',
    editorTabFrameTitle: 'Klicken Sie hier, um einen Bilderrahmen hinzuzufügen',
    editorTabImagesTitle: 'Hochgeladene Bilder',
    editorTabImagesUpload: 'Bild hochladen',
    editorTabImagesSetBackground: 'Als Hintergrundbild festlegen',
    editorTabImagesProcessing: 'Wird bearbeitet...',
    editorTabHideFromUser: 'Vor Benutzer verstecken',
    editorTabShow: 'Zeige alles',
    editorTabPlaceholdersContent: 'Platzhalterinhalt',
    editorTabProjectsBack: 'Zurück zu den Projekten',
    editorTabProjectsWarning: 'Warnung!',
    editorTabProjectsOverwrite: 'Dieses Layout enthält verschiedene Datensätze. Einige Ihrer Arbeiten werden möglicherweise überschrieben.',
    editorTabProjectsApplyNewLayout: 'Neues Layout anwenden',
    editorTabProjectsHide: 'Ausblenden',
    editorTabProjectsNoLayouts: 'Derzeit sind keine Projekte für dieses Format verfügbar.',
    editorSceneProjectId: 'Projekt-ID:',
    editorScenePriceConfig: 'Produkt Konfiguration',
    editorScenePriceSummary: 'Zusammenfassung',
    editorScenePriceNet: 'Preis netto',
    editorScenePriceVAT: 'Preis MwSt',
    editorScenePriceTotal: 'Preis brutto',
    editorSceneElementOptionsAdjustImage: 'Passen Sie das Bild an',
    editorSceneElementOptionsLastUsedColors: 'Zuletzt verwendete Farben',
    editorSceneElementOptionsWidth: 'Breite',
    editorSceneElementOptionsHeight: 'Höhe',
    editorSceneElementOptionsSize: 'Größe',
    editorSceneElementOptionsColors: 'Farben',
    editorSceneElementOptionsSetQRSize: 'Stellen Sie die QR-Größe ein',
    editorSceneElementOptionsSetQRColor: 'Stellen Sie die QR-Farbe ein',
    editorSceneElementOptionsDelete: 'Element löschen',
    editorSceneElementOptionsLock: 'Verriegelungselement',
    editorSceneElementOptionsNoPlaceholder: 'Kein Platzhalter',
    editorSceneElementOptionsSetPlaceholder: 'Platzhalter für Element festlegen',
    editorSceneElementOptionsSetPosition: 'Elementposition einstellen',
    editorSceneElementOptionsSetVisibility: 'Alle Elemente ein- / ausblenden',
    editorSceneElementOptionsPushToFront: 'Element nach vorne schieben',
    editorSceneElementOptionsPushToBack: 'Element nach hinten schieben',
    editorSceneElementOptionsFontFamily: 'Wählen Sie die Schriftfamilie',
    editorSceneElementOptionsFontWeight: 'Wählen Sie die Schriftgröße',
    editorSceneElementOptionsFontSize: 'Wählen Sie die Schriftgröße',
    editorSceneElementOptionsTextAlign: 'Text ausrichten',
    editorSceneElementOptionsTextCapitalize: 'Großschreiben von Text',
    editorSceneElementOptionsTextUnderline: 'Text unterstreichen',
    editorSceneElementOptionsPublishProject: 'Projekt veröffentlichen',
    editorSceneElementOptionsPublished: 'Veröffentlicht',
    editorSceneElementOptionsPublish: 'Veröffentlichen',
    editorSceneElementOptionsSave: 'Projekt speichern',
    editorSceneElementOptionsSaveDesign: 'Design speichern',
    editorSceneElementOptionsSaveAndAdd: ' und in den Warenkorb legen',
    editorSceneElementOptionsValidationErrorMsg: 'Elemente haben die Validierung nicht bestanden. Korrigieren Sie sie, um das Projekt zu speichern.',
    editorSceneElementOptionsValidationValue: 'Elementwert:',
    editorSceneElementOptionsValidationError: 'error:',
    editorScenePageBackgroundSettings: 'Seitenhintergrundeinstellungen',
    editorScenePageBackgroundSize: 'Hintergrundgröße',
    editorScenePageBackgroundCustomSize: 'Benutzerdefiniertes Format',
    editorScenePageBackgroundPosition: 'Hintergrundposition',
    editorScenePageBackgroundRepeat: 'Hintergrund Wiederholung',
    editorScenePageBackgroundAdditional: 'Zusätzliche Optionen',
    editorScenePageBackgroundRemove: 'Hintergrund entfernen',
    editorScenePageBackgroundColor: 'Hintergrundfarbe',
    editorScenePageCornerRadius: 'Seiteneckenrundung',
    editorScenePageNumber: 'Seite {num1} von {num2}',
    editorScenePageShowPrevious: 'Vorherige Seite anzeigen',
    editorScenePageShowNext: 'Nächste Seite anzeigen',
    editorScenePageSettings: 'Seiteneinstellungen',
    editorScenePageAddNew: 'Neue Seite hinzufügen',
    editorScenePageDelete: 'Seite löschen',
    editorScenePageLock: 'Seite sperren',
    editorScenePageWarning: 'Diese Seite enthält Elemente. Wollen Sie fortfahren?',
    editorScenePageDeleteConfirm: 'Ja, Seite löschen'
}